module.exports = rmlOpts;